import { render, staticRenderFns } from "./TopProjectsBySavings.vue?vue&type=template&id=7d6915f3&scoped=true&"
import script from "./TopProjectsBySavings.vue?vue&type=script&lang=js&"
export * from "./TopProjectsBySavings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6915f3",
  null
  
)

export default component.exports